module.exports = __webpack_public_path__ + "img/cloud.a24f3f37.png";